import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Relay} from '../classes/Relay';

const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

@Injectable({
  providedIn: 'root',
})
export class RelayService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<Relay[]> {
    return this.httpClient.get<Relay[]>(`${environment.backendApiUrl}/v1/relays`, {headers});
  }

  public getByRelayBoard(relayBoardId: number): Observable<Relay[]> {
    const params = new HttpParams().append('relayBoardId', relayBoardId);
    return this.httpClient.get<Relay[]>(`${environment.backendApiUrl}/v1/relays`, {params, headers});
  }

  public addOrEdit(relay: Relay): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/relays`, relay, {headers});
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/relays/` + id, {headers});
  }
}
